import { SVGIconProps } from "@faire/slate-icons/types";
import { tsv } from "@faire/slate/lib/tsv";
import React from "react";

import { FilterIcon } from "./FilterIcon";

type IProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  Icon?: React.FC<SVGIconProps>;
  label: React.ReactNode;
};

export const FilterButtonBase = ({
  className,
  Icon,
  label,
  ...props
}: IProps) => {
  const filterButtonCls = filterButtonStyle.cls({
    className,
  });
  return (
    <button type="button" className={filterButtonCls} {...props}>
      {Icon ? <FilterIcon Icon={Icon} /> : null}
      <span className="fs-filter__label">{label}</span>
    </button>
  );
};

const filterButtonStyle = tsv({
  vars: {
    textColor: "fs-filter-text-color",
    iconColor: "fs-filter-icon-color",
    backgroundColor: "fs-filter-background-color",
    borderColor: "fs-filter-border-color",
  },
  base: "fs-filter focusable interactive",
});

export const filterButtonVars = filterButtonStyle.vars;
